import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ServiceDetailLayout from "./ServiceDetailLayout";
import FaqItem from "./FaqItem";

const snapshot = {
  price: "a partir de 300 000 FCFA",
  delay: "2 a 4 semaines",
  idealFor: "Boutiques mode, cosmetiques, alimentation, artisans",
};

const sections = [
  { id: "intro", label: "Ce qu'on fait" },
  { id: "pour-qui", label: "Pour qui ?" },
  { id: "fonctionnalites", label: "Ce qu'on inclut" },
  { id: "paiement", label: "Orange Money & Wave" },
  { id: "process", label: "Notre methode" },
  { id: "faq", label: "FAQ" },
];

export default function EcommerceDetail() {
  return (
    <>
      <Helmet>
        <title>Boutique en ligne & E-commerce — NEXUS SOLUTIONS</title>
        <meta name="description" content="Creation de boutiques en ligne avec paiement Orange Money et Wave integres. Vendez en Cote d'Ivoire 24h/24. A partir de 300 000 FCFA. Devis gratuit." />
        <meta property="og:title" content="E-commerce & Boutique en ligne — NEXUS SOLUTIONS" />
        <meta property="og:description" content="Boutique en ligne sur mesure avec Orange Money, Wave et gestion de stock. Marche ivoirien, livraison 2 a 4 semaines." />
      </Helmet>

      <ServiceDetailLayout title="E-commerce & Boutique en ligne" summarySections={sections} snapshot={snapshot}>

        <section id="intro">
          <h2>Ce qu'on fait</h2>
          <p>
            Nous creeons des boutiques en ligne sur mesure adaptees au marche
            ivoirien. Que vous vendiez des vetements, de la nourriture, des
            cosmetiques ou des services, on vous construit une plateforme
            simple a gerer et facile a utiliser pour vos clients.
          </p>
          <p>
            Une boutique standard est livree en <strong>2 a 4 semaines</strong>
            et inclut tout ce qu'il faut pour commencer a vendre immediatement,
            y compris Orange Money et Wave.
          </p>
        </section>

        <section id="pour-qui">
          <h2>Pour qui ?</h2>
          <p>Si vous vendez un produit ou service et voulez recevoir des commandes et des paiements en ligne, une boutique e-commerce est faite pour vous.</p>
          <div className="for-who-grid">
            <div className="for-who-card">
              <span className="for-who-card__emoji">👗</span>
              <div className="for-who-card__label">Boutiques de mode</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">💄</span>
              <div className="for-who-card__label">Cosmetiques & beaute</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">🥘</span>
              <div className="for-who-card__label">Traiteurs & alimentation</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">🛠</span>
              <div className="for-who-card__label">Artisans & createurs</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">📦</span>
              <div className="for-who-card__label">Revendeurs & grossistes</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">📚</span>
              <div className="for-who-card__label">Vente de formations</div>
            </div>
          </div>
        </section>

        <section id="fonctionnalites">
          <h2>Ce qu'on inclut</h2>
          <ul>
            <li>Catalogue produits avec photos, prix et descriptions</li>
            <li>Panier et tunnel de commande simplifie</li>
            <li>Gestion des stocks et des commandes</li>
            <li>Espace client (historique des commandes, suivi de livraison)</li>
            <li>Interface admin — vous gerez vos produits vous-meme</li>
            <li>Design responsive — parfait sur telephone</li>
            <li>Notifications automatiques aux clients (email ou SMS)</li>
          </ul>
        </section>

        <section id="paiement">
          <h2>Paiement mobile — Orange Money & Wave</h2>
          <p>
            C'est notre point fort : on integre les paiements mobile money directement
            dans votre boutique. Vos clients paient avec <strong>Orange Money</strong> ou
            <strong> Wave</strong> en quelques secondes, sans avoir besoin d'une carte bancaire.
          </p>
          <p>
            En Cote d'Ivoire, plus de 70% des paiements en ligne passent par le mobile money.
            Si votre boutique ne l'accepte pas, vous perdez la majorite de vos clients potentiels.
          </p>
          <p>
            On integre egalement les cartes bancaires via des partenaires locaux pour les clients
            qui preferent ce mode de paiement.
          </p>
        </section>

        <section id="process">
          <h2>Notre methode</h2>
          <ol>
            <li><strong>Echange</strong> — On discute de vos produits, de votre mode de livraison et de vos besoins.</li>
            <li><strong>Design</strong> — On vous montre a quoi ressemblera votre boutique avant de coder.</li>
            <li><strong>Developpement</strong> — On integre vos produits et on connecte Orange Money et Wave.</li>
            <li><strong>Formation & livraison</strong> — On met en ligne et on vous forme a gerer votre boutique.</li>
          </ol>
        </section>

        <section id="faq">
          <h2>FAQ</h2>
          <FaqItem question="Combien ca coute ?">
            Une boutique avec Orange Money/Wave demarre a partir de 300 000 FCFA. Le prix varie selon le nombre de produits et les fonctionnalites souhaitees. Consultez nos <Link to="/tarifs" style={{ color: '#4b004b' }}>formules et tarifs</Link> pour les packs complets.
          </FaqItem>
          <FaqItem question="Est-ce que je peux gerer mes produits moi-meme ?">
            Oui. On vous cree une interface d'administration simple et intuitive. Vous ajoutez, modifiez ou supprimez vos produits sans avoir besoin d'un developpeur.
          </FaqItem>
          <FaqItem question="Est-ce que je recois vraiment les paiements Orange Money sur mon compte ?">
            Oui. Les paiements arrivent directement sur votre compte Orange Money ou Wave professionnel. On s'occupe de toute la configuration technique de l'integration.
          </FaqItem>
          <FaqItem question="La livraison est-elle incluse dans votre solution ?">
            On integre un systeme de gestion de livraison basique. Pour des besoins complexes (plusieurs livreurs, tracking GPS), on vous propose une solution adaptee, discutee lors du cadrage.
          </FaqItem>
          <FaqItem question="Ma boutique sera-t-elle visible sur Google ?">
            Oui. On integre les bases du SEO e-commerce (balises produits, vitesse, responsive). Vos fiches produits peuvent apparaitre dans les resultats de recherche Google.
          </FaqItem>

          <div style={{ marginTop: '2rem', textAlign: 'center' }}>
            <Link
              to="/devis"
              style={{
                background: '#4b004b', color: '#fff', padding: '13px 36px',
                borderRadius: '28px', fontWeight: 700, textDecoration: 'none',
                fontSize: '1rem', display: 'inline-block',
              }}
            >
              Demander un devis gratuit
            </Link>
          </div>
        </section>

        <div className="related-services">
          <div className="related-services__title">Vous pourriez aussi avoir besoin de</div>
          <div className="related-services__grid">
            <Link to="/services/developpement-web" className="related-service-card">
              <span className="related-service-card__icon">🌐</span>
              <div className="related-service-card__body">
                <div className="related-service-card__title">Site Web</div>
                <div className="related-service-card__desc">Vitrine, landing page, app web</div>
              </div>
              <span className="related-service-card__arrow">→</span>
            </Link>
            <Link to="/services/applications-mobiles" className="related-service-card">
              <span className="related-service-card__icon">📱</span>
              <div className="related-service-card__body">
                <div className="related-service-card__title">Application Mobile</div>
                <div className="related-service-card__desc">iOS & Android, React Native</div>
              </div>
              <span className="related-service-card__arrow">→</span>
            </Link>
          </div>
        </div>

      </ServiceDetailLayout>
    </>
  );
}
